/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_TitleInputs */

const en_register_onboarding_terms_title = /** @type {(inputs: Register_Onboarding_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consent before submission`)
};

const de_register_onboarding_terms_title = /** @type {(inputs: Register_Onboarding_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einwilligung vor dem Absenden`)
};

/**
* | output |
* | --- |
* | "Consent before submission" |
*
* @param {Register_Onboarding_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_terms_title = /** @type {((inputs?: Register_Onboarding_Terms_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_title(inputs)
	return en_register_onboarding_terms_title(inputs)
});